import { render, staticRenderFns } from "./crudOrdersSeller.vue?vue&type=template&id=a20a7e3e&scoped=true&"
import script from "./crudOrdersSeller.vue?vue&type=script&lang=js&"
export * from "./crudOrdersSeller.vue?vue&type=script&lang=js&"
import style0 from "./crudOrdersSeller.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudOrdersSeller.vue?vue&type=style&index=1&id=a20a7e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20a7e3e",
  null
  
)

export default component.exports